import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { dispatcher } from 'dispatcher';

import { showUpgradeMemberPopupAction } from '../actions';
import { EVENT_UPGRADE_MEMBER_POPUP } from '../constants';

export const useListenShowUpgradeMemberPopup = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const showPopup = (popupData?: { membershipNumber: string }) => dispatch(showUpgradeMemberPopupAction(popupData));

        dispatcher.listen(EVENT_UPGRADE_MEMBER_POPUP, showPopup);

        return () => {
            dispatcher.removeListener(EVENT_UPGRADE_MEMBER_POPUP, showPopup);
        };
    }, [dispatch]);
};
